import { get, post } from './http-calls';

export let getTCardEventTypesByID = async (id) => {
    let data = await get(`TCardEventTypes/TCardEventTypeGetDetails?TCardEventTypeID=${id}`, { useAuthToken: true });
    return data;
};

export const postTCardEventTypes = async (data) => {
    let res = await post(`TCardEventTypes/TCardEventTypeAddUpdate`, data, { useAuthToken: true });
    return res;
};